import Vue from "vue";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vant from "vant";
import { Toast } from "vant";
import "vant/lib/index.css";
import "amfe-flexible/index.js";
import "lib-flexible/flexible";

import './fonts/font.css'
import '../src/utils/flexible.js'

Vue.use(ElementUI);
Vue.use(Vant);
Vue.use(Toast);
Vue.config.productionTip = false;
Vue.prototype.$vant = Vant;

new Vue({
  router,
  store,
  el: '#app',
  render: (h) => h(App),
}).$mount("#app");
